import toast from 'react-hot-toast';

import { APP_CONSTANTS } from '@constants/app.constants';

export const getErrorMessage = (error) => {
  if (!error) return 'An unexpected error occurred';

  if (typeof error === 'string') return error;

  if (error.response?.data?.message) return error.response.data.message;
  if (error.response?.data?.error) return error.response.data.error;

  const responseData = error.response?.data?.data;
  if (Array.isArray(responseData) && responseData.length > 0) {
    const first = responseData[0];
    if (typeof first === 'string') return first;
    if (first?.message) return first.message;
  }

  if (Array.isArray(error.response?.data?.errors) && error.response.data.errors.length > 0) {
    return error.response.data.errors[0];
  }

  if (error.message) return error.message;

  return 'An unexpected error occurred';
};

export const getFieldErrors = (error) => {
  const responseData = error?.response?.data?.data;
  if (!Array.isArray(responseData)) return [];

  return responseData
    .filter((item) => item?.field && item?.message)
    .map((item) => ({
      field: item.field,
      message: item.message,
    }));
};

export const handleApiError = (error, { silent = false } = {}) => {
  const status = error?.response?.status;
  const message = getErrorMessage(error);

  if (!silent) {
    if (status === APP_CONSTANTS.HTTP_STATUS.UNAUTHORIZED) {
      toast.error(message || 'Session expired. Please sign in again.');
    } else if (status === APP_CONSTANTS.HTTP_STATUS.FORBIDDEN) {
      toast.error('You do not have permission to perform this action.');
    } else if (status === APP_CONSTANTS.HTTP_STATUS.NOT_FOUND) {
      toast.error('The requested resource was not found.');
    } else if (status >= APP_CONSTANTS.HTTP_STATUS.SERVER_ERROR) {
      toast.error('A server error occurred. Please try again later.');
    } else {
      toast.error(message);
    }
  }

  return {
    status,
    message,
    data: error?.response?.data ?? null,
    originalError: error,
  };
};

export const globalErrorHandler = (error, errorInfo) => {
  console.error('Global error:', error, errorInfo);
};
